import { render, staticRenderFns } from "./UiRow.vue?vue&type=template&id=8eae96ee&lang=pug&"
import script from "./UiRow.vue?vue&type=script&lang=js&"
export * from "./UiRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports